import React, { createContext, useContext, useMemo, useState } from 'react';
import apiClient from '../api/apiClient';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [accessToken, setAccessToken] = useState(() => localStorage.getItem('accessToken'));
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('authUser');
    return stored ? JSON.parse(stored) : null;
  });

  const login = async ({ email, password }) => {
    const response = await apiClient.post('/auth/login', { email, password });
    const token = response.data?.data?.accessToken;
    const userData = response.data?.data?.user;
    if (token) {
      localStorage.setItem('accessToken', token);
      setAccessToken(token);
    }
    if (userData) {
      localStorage.setItem('authUser', JSON.stringify(userData));
      setUser(userData);
    }
  };

  const logout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('authUser');
    setAccessToken(null);
    setUser(null);
  };

  const value = useMemo(() => ({
    accessToken,
    user,
    isAuthenticated: Boolean(accessToken),
    login,
    logout
  }), [accessToken, user]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
